import { Tool, ToolSupportLevel } from '__generated__/api-types-and-hooks'
import React, { FC } from 'react'

interface IToolsLabelProps {
  tool: Tool
  isToolDisconnecting: boolean
}
const ToolsLabel: FC<IToolsLabelProps> = ({ tool, isToolDisconnecting }) => {
  const isToolConnectable = tool.supportLevel !== ToolSupportLevel.Open
  return (
    <div className={`${isToolDisconnecting ? 'pt-0' : 'pt-7'}`}>
      {isToolConnectable && (
        <p className="text-xs text-grey-lighter5x">
          {/* {tool.isRecommended && 'Backed by GoTackle'} */}
          {tool.isRecommended &&
            tool.relatedPlays?.length! > 0 &&
            ` (${tool.relatedPlays?.length} available plays)`}
        </p>
      )}
      <p className="text-lg text-primary-text leading-6 font-bold my-2">
        {tool.toolDisplayName ?? tool.toolName}
      </p>
    </div>
  )
}

export default ToolsLabel
